const commentImageSrc =
  /(\bsrc\s*=\s*["'])(?:https?:\/\/[^"'\s]*?)?(\/fileSystemServer\/getCommentImage\/)/gi;

/**
 * ⚠️ KNOWN BUG (save, as on staging CUBE-32780): the pattern reads sanitize-html's serialized output, not the
 * `src` attribute. Text keeps its quotes there, so a text run such as
 * `src="https://a<b>x</b>/fileSystemServer/getCommentImage/k.png` loses `https://a<b>x</b>` (the user's word and
 * its tags) on save. Nothing is added, so nothing unsafe is stored. Fix: strip the host on the parsed `src` of an
 * `img` in sanitize-html's `transformTags`.
 */
export const stripCommentImageHost = (html: string) =>
  html.replace(commentImageSrc, "$1$2");

/**
 * ⚠️ KNOWN BUG (e-mail `emailSafeHtml` and the comment thread's `resolveCommentImages`, as on staging
 * CUBE-32780): this rewrites the RAW string, before it is parsed. A `src="https://…` inside a comment, a raw-text
 * element or another attribute matches too, and the rewrite deletes everything from there to the route (a
 * comment's `-->`, a `<style>`'s close, a tag's `>`), so the parse then shows markup that was hidden, or hides
 * what followed. E-mail sanitizes after the rewrite with its own allow-list (staging's), and stored comments come
 * from `zSafeHtmlWithImages` (no comment or raw-text element survives it), so neither goes past what save and
 * e-mail allow. Fix: put the host on the parsed value, as web display does (`commentImageSrcWithHost` in
 * `sanitizeHtml`'s walk): in `emailSafeHtml`'s `img` transform, and on each `img` of a parsed copy in
 * `resolveCommentImages`.
 */
export const withCommentImageHost = (html: string, backendUrl: string) => {
  const origin = backendUrl.replace(/\/+$/, "");
  return html.replace(
    commentImageSrc,
    (_, attr: string, path: string) => `${attr}${origin}${path}`,
  );
};

/** The image route at the start of one `src` value, after any `http(s)://` host. */
const commentImageRoute = /^(?:https?:\/\/[^"'\s]*?)?(\/fileSystemServer\/getCommentImage\/)/i;

/**
 * One PARSED `img` `src` value with the backend's host put back in front of the image route (any host it carries is
 * replaced); any other value is returned as it is. Web display (`sanitizeHtml`) calls it on each `img` source of its
 * walk, so only a source the browser will load is rewritten, however the markup spelled it (an entity, no quotes).
 */
export const commentImageSrcWithHost = (src: string, backendUrl: string) => {
  const origin = backendUrl.replace(/\/+$/, "");
  return src.replace(commentImageRoute, (_, path: string) => `${origin}${path}`);
};
